import { nanoid } from 'nanoid'
import React from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import Loading from '../Loading'

import st from './index.scss'

const loadableRouter = (router) =>
  Object.keys(router).map((key) => {
    return {
      path: key,
      element: router[key]
    }
  })

export default function MakeRoutes({ routers }) {
  const is_zhuma = window.location.host.indexOf('zhuma') !== -1
  return (
    <Routes>
      {loadableRouter(routers).map((item, idx) => (
        <Route
          key={idx}
          path={item.path}
          element={
            <item.element fallback={<div className={st['loading']}><Loading /></div>}></item.element>
          }
        />
      ))}
      {is_zhuma ? 
      <Route path="/fakao" element={<Navigate to="/"></Navigate>}></Route> 
      : null }
    </Routes>
  )
}
